module.exports = __webpack_public_path__ + "static/media/4ODA3.a588b9b1.jpg";